export interface PopupItemType {
  item_type: string
  content: string
  formated_content: string
  link_text: string
  link_url: string
  highlight_text: string | null
  highlight_color: string | null
  checkbox_value: boolean
}

export interface PopupDataType {
  popup_type: string
  popup_items: PopupItemType[]
  icon: string
}

interface PopupContentType {
  popupAtStep3: PopupDataType[]
}

export const initialState: PopupContentType = {
  popupAtStep3: [],
}
